import cx from 'classnames'

type Props = { className?: string }

const FormError: React.FC<Props> = ({ children, className }) => (
  <div className={cx('mt-2 text-red-500 capitalize-first', className)}>
    {children}
  </div>
)

export default FormError
